import * as React from 'react';
export const BQSvg = React.forwardRef(function BQSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F6F9FC',
      d: 'M0 6h16v4H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#EAEEF3',
      d: 'M15 10V6h1v4h-1ZM0 6h1v4H0V6Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#E25950',
      d: 'M16 4v2H0V4c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#43458B',
      d: 'M0 12v-2h16v2a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2Z',
    }),
  );
});
BQSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  fill: 'none',
  viewBox: '0 0 16 16',
};
export var BQ = {
  category: 'flag',
  colorable: false,
  name: 'BQ',
  svg: BQSvg,
};
